// extracted by mini-css-extract-plugin
export var heroSection = "index-module--heroSection--JFpi3";
export var comingSoon = "index-module--comingSoon--1JM4t";
export var heroCredit = "index-module--heroCredit--3yKUk";
export var heroText = "index-module--heroText--3FbP-";
export var accent = "index-module--accent--ALk6f";
export var heroBg = "index-module--heroBg--1v37U";
export var heroImg = "index-module--heroImg--1v5nc";
export var splash = "index-module--splash--2u-so";
export var layoutBox = "index-module--layoutBox--5b3yq";